module.exports = __webpack_public_path__ + "img/bsz.4ca787e8.jpg";